import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={17.572}
    height={25.989}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 14943 22101"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:244.916}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974535738944">
        <path
          d="M1617 1538v11319c0 180 139 353 391 512 840 529 2942 904 5402 904s4563-375 5402-904c252-159 391-332 391-512V1538c0-181-139-353-391-512-839-529-2942-904-5402-904s-4562 375-5402 904c-252 159-391 331-391 512zm1296 10427V2430c1063 319 2682 523 4497 523s3434-204 4496-523v9535c-1062-320-2681-524-4496-524s-3434 204-4497 524zm9641-10427c0 499-2303 903-5144 903s-5145-404-5145-903 2304-904 5145-904 5144 405 5144 904zM7410 11954c2841 0 5144 404 5144 903s-2303 903-5144 903-5145-404-5145-903 2304-903 5145-903zM4534 14703 188 20650l1122 512 4347-5947zM6762 15111v6867h1296v-6867zM9287 15215l4345 5947 1123-512-4346-5947z"
          className="fil0"
        />
        <path
          d="M1617 1538v11319c0 180 139 353 391 512 840 529 2942 904 5402 904s4563-375 5402-904c252-159 391-332 391-512V1538c0-181-139-353-391-512-839-529-2942-904-5402-904s-4562 375-5402 904c-252 159-391 331-391 512zm1296 10427V2430c1063 319 2682 523 4497 523s3434-204 4496-523v9535c-1062-320-2681-524-4496-524s-3434 204-4497 524zm9641-10427c0 499-2303 903-5144 903s-5145-404-5145-903 2304-904 5145-904 5144 405 5144 904zM7410 11954c2841 0 5144 404 5144 903s-2303 903-5144 903-5145-404-5145-903 2304-903 5145-903zM4534 14703 188 20650l1122 512 4347-5947zM6762 15111v6867h1296v-6867zM9287 15215l4345 5947 1123-512-4346-5947z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
